import {
    LIST_PARAMS,
    LIST_PARAMS_SUCCESS,
    LIST_PARAMS_ERROR
} from '../types';

import es from '../lang/es';
import api from '../helpers/api';
import apiMethods from '../constants/apiMethods';

//LISTAR CATEGORIAS
export function listParamsAction() {
    return async (dispatch) => {
        //Inicializo
        dispatch( listParams() );
        //Ejecuto la consulta
        try{
            //Hago la consulta de fueros
            const responseJurisdictions = await api.get(apiMethods.JURISDICTIONS);
            //Obtengo los datos
            const resJurisdictions = responseJurisdictions.data;
            //Hago la consulta de estados
            const responsePaymentStates = await api.get(apiMethods.PAYMENT_STATES);
            //Obtengo los datos
            const resPaymentStates = responsePaymentStates.data;
            //Hago la consulta de tipos (padres)
            const responsePaymentTypes = await api.get(apiMethods.PAYMENT_TYPES);
            //Obtengo los datos
            const resPaymentTypes = responsePaymentTypes.data;
            //Armo el resultado
            const params = {
                jurisdictions: resJurisdictions.data,
                paymentStates: resPaymentStates.data,
                paymentTypes: resPaymentTypes.data
            }
            //Llamo al dispatch
            dispatch( listParamsSuccess(params) );
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: es.ERRORS.SERVER_CONN
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Dispatch
            dispatch( listParamsError(data) );
        }
    }
}

const listParams = () => ({
    type: LIST_PARAMS,
    payload: true
});

const listParamsSuccess = params => ({
    type: LIST_PARAMS_SUCCESS,
    payload: params
});

const listParamsError = error => ({
    type: LIST_PARAMS_ERROR,
    payload: error
});